import React from 'react';
import { Building2 } from 'lucide-react';
import { trustData } from '../data/mockData';

const TrustSection = () => {
  return (
    <section className="py-16 bg-[#111111] border-y border-[#2a2a2a]">
      <div className="container">
        <div className="text-center mb-10">
          <h2 className="heading-2 text-white mb-2">
            {trustData.headline}
          </h2>
          <p className="body-regular text-[#808080]">
            {trustData.subheadline}
          </p>
        </div>
        
        {/* Client logos/names */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {trustData.clients.map((client, index) => (
            <div 
              key={index}
              className="flex flex-col items-center justify-center p-4 bg-[#0a0a0a] border border-[#2a2a2a] hover:border-[#c9a962]/30 transition-colors"
            >
              <Building2 size={24} className="text-[#c9a962] mb-2" strokeWidth={1.5} />
              <span className="text-sm text-white text-center font-medium">{client.name}</span>
              <span className="text-xs text-[#808080] text-center">{client.type}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
